module.exports = __webpack_public_path__ + "img/bg-knife.489be0f8.svg";